export default {
  'update/pageMap': (state, newPageMap) => {
    const { pageMap } = state
    state.pageMap = { ...pageMap, ...newPageMap }
  },
  'update/articleMap': (state, newArticleMap) => {
    const { articleMap } = state
    state.articleMap = { ...articleMap, ...newArticleMap }
  },
  'update/settings': (state, newSettings) => {
    const { settings } = state.content
    state.content.settings = { ...settings, ...newSettings }
  },
  'update/content': (state, newContent) => {
    const { content } = state
    state.content = { ...content, ...newContent }
  },
  'update/categories': (state, { categories, lang }) => {
    const newsCategories = state.taxonomies.newsCategories[lang]
    state.taxonomies.newsCategories[lang] = { ...newsCategories, ...categories }
  },
  'update/articles': (state, newArticles) => {
    state.collections.articles = newArticles
  },
  'replace/documents': (state, documents) => {
    state.collections.documents = documents
  }
}
